<template>
  <div>
    <a-page-header style="width: 105%;margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart" />
            <span>{{ $t("message.userGroupList.audience") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="user-add" />
            <span>{{ $t('message.addUserGroup.AudienceExploration') }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t('message.addUserGroup.AudienceExploration') }}</div>

    <!--  Random Modal  -->
    <a-modal :visible="shrinkUser" width="60%" okText="随机抽取" cancelText="取消" @ok="shrinkUserOk"
      @cancel="shrinkUserCancel" icon="question-circle" destroyOnClose>
      <template slot="title">
        <h1>随机抽取</h1>
      </template>
      <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" :model="shrinkForm">
        <a-form-item>
          <span :style="{
            color: shrinkForm.shrink_switch ? '#000000' : 'black',
            fontWeight: shrinkForm.shrink_switch ? 'normal' : 'bold'
          }">按人数随机抽取</span>
          <a-switch :disabled="reload" v-model="shrinkForm.shrink_switch" @change="shrinkSwitchChange" :style="{
            margin: '0 20px',
            backgroundColor: shrinkForm.shrink_switch ? '#dd0031' : 'black'
          }" />
          <span :style="{
            color: shrinkForm.shrink_switch ? '#dd0031' : '#000000',
            fontWeight: shrinkForm.shrink_switch ? 'bold' : 'normal'
          }">按百分比随机抽取</span>
        </a-form-item>

        <a-form-item style="margin-top: 20px">
          <div>
            <a-row :gutter="8">
              <a-col :md="4" :xxl="2" style="line-height: 36px">
                <h4>随机抽取</h4>
              </a-col>
              <a-col :md="15" :xxl="12" v-if="shrinkForm.shrink_switch">
                <a-slider :disabled="reload" :step="10" v-model="shrinkForm.shrink_slide" :min="10" :max="100"
                  :tip-formatter="shrinkSlideFormatter" @change="shrinkSlideChange" />
              </a-col>
              <a-col :md="5" :xxl="4">
                <a-input-number :size="$globalSize" :disabled="reload" v-model="shrinkForm.shrink_input" :min="10"
                  :max="shrinkForm.shrink_user_num" />
                <span>人</span>
              </a-col>
            </a-row>
            <a-row :gutter="8">
              <a-col :md="{ offset: 4, span: 20 }" :xxl="{ offset: 2, span: 22 }">
                总人数： {{ shrinkForm.shrink_user_num }} 人
              </a-col>
            </a-row>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--  Save Modal  -->
    <a-modal v-model="saveModal" :maskClosable="false" :title="$t('message.customGroup.SaveAudience')">
      <template slot="footer">
        <a-button :size="$globalSize" key="back" @click="closeSaveModal">
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <a-button :size="$globalSize" key="submit" type="primary" :loading="loadingSpin" :disabled="spinningBtn"
          @click="saveBtn">
          {{ $t('message.commonUsage.save') }}
        </a-button>
      </template>
      <a-spin :spinning="spinningBtn">
        <a-form-model ref="saveForm" :rules="saveFormRules" :model="saveForm" :label-col="labelCol"
          :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('message.customGroup.UserCount')">
            <span :loading="loadingSpin" style="font-weight: bold">{{ showThousandNum(popNum) }}</span>
            <!--          <a style="margin-left:80px" @click="loadPopulation()">预览用户数</a>-->
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.CalculationType')" prop="group_type">
            <a-radio-group :size="$globalSize" v-model="saveForm.group_type" :disabled="reload">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ $t('message.customGroup.DynamicTip') }}</span>
                </template>
                <a-radio value="1"> {{ $t('message.customGroup.Dynamic') }}</a-radio>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ $t('message.customGroup.StaticTip') }}</span>
                </template>
                <a-radio value="2"> {{ $t('message.customGroup.Static') }}</a-radio>
              </a-tooltip>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.title4')" prop="group_name">
            <a-input :size="$globalSize" v-model.trim="saveForm.group_name" :maxLength="64" :disabled="reload" />
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.AudienceIDGenerate')" prop="autoid">
            <a-radio-group :size="$globalSize" v-model="saveForm.autoid" :disabled="autoidDisable">
              <a-radio :value="0" disabled>{{ $t('message.customGroup.Manually') }}</a-radio>
              <a-radio :value="1">{{ $t('message.customGroup.Autogen') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.title5')" prop="group_id" v-if="saveForm.autoid === 0">
            <!-- <a-input :size="$globalSize" v-model.trim="saveForm.group_id" :disabled="reload"/> -->
            <a-input-number :size="$globalSize" style="width:100%" :min="1" :max="9007199254740992" :step="1"
              v-model="saveForm.group_id" :disabled="reload || people_id_reload" />
          </a-form-model-item>
          <a-row v-if="saveForm.autoid === 0" style="margin-top:-20px;margin-bottom:20px;color:red;font-size:12px">
            <a-col :span="6"></a-col>
            <a-col :span="12">（{{ $t('message.customGroup.AudienceIDRange') }}：1~9,007,199,254,740,992）</a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-spin :spinning="reload">
      <a-card class="header-title" :title="$t('message.addUserGroup.FilterExploration')" style="margin-top: 30px">

        <div v-if="unionForm.domains.length">
          <a-form-model ref="unionForm" :model="unionForm" v-bind="formItemLayoutWithOutLabel" id="unionForm">
            <div v-for="(domain, index) in unionForm.domains" :style="{ marginTop: index != 0 ? '20px' : '30px' }"
              :key="index">
              <a-tabs type="card" class="tab-gradient tab-and-or"
                :activeKey="typeof domain[0] != 'undefined' && typeof domain[0].apposition != 'undefined' ? domain[0].apposition : '且'"
                v-if="index != 0" @change="tabUnionChange">
                <a-tab-pane key="且">
                  <div slot="tab" style="font-family: PingFangSC;height: 32px;line-height: 32px">AND</div>
                </a-tab-pane>
                <a-tab-pane key="或" style="margin-left:20px;">
                  <div slot="tab" style="font-family: PingFangSC;height: 32px;line-height: 32px;">OR</div>
                </a-tab-pane>
              </a-tabs>
              <a-card :style="{ marginTop: index != 0 ? '0px' : '0px' }" class="unionFormCard">
                <div class="close-total-filter">
                  <a-icon type="close" @click="removeUnionDomain(index)" />
                </div>
                <a-row :gutter="16" v-for="(child, childIndex) in domain" :key="child.key">
                  <a-col :md="{ span: 2 }" :xxl="{ span: 1 }" v-if="childIndex != 0">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <span style="font-size: 14px;font-weight: 500;float: right">{{
                        child.apposition == '且' ? 'AND:' : 'OR:'
                      }}</span>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 6 }" :xxl="{ span: 6 }">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.tag_name'" :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SelectLabel'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-spin :spinning="loadingLabel">
                        <a-cascader :size="$globalSize" class="cascader-container" style="width: 100%"
                          :getPopupContainer="(triggerNode) => { return triggerNode.parentNode }"
                          v-model="child.tag_name" :options="tagAll.options" :show-search="{ filter }"
                          :placeholder="$t('message.addUserGroup.SelectLabel')"
                          @change="handleUnionChildTagChange(index, childIndex, child)" />
                        <!-- <a-tree-select :size="$globalSize"
                            v-model="child.tag_id"
                            show-search
                            :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode }"
                            style="width: 100%"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            placeholder="请选择标签"
                            allow-clear
                            treeNodeFilterProp="title"
                            :tree-data="tagAll.options"
                            @change="handleUnionChildTagChange(index, childIndex,child)"
                        >
                        </a-tree-select> -->
                      </a-spin>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 3 }" :xxl="{ span: 3 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.calc'" :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SelectCalculationRule'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" :default-value="child.calc" v-model="child.calc" style="width: 100%"
                        :getPopupContainer="(triggerNode) => { return triggerNode.parentNode }"
                        :placeholder="$t('message.addUserGroup.SelectCalculationRule')">
                        <a-select-option v-for="calc in child.calcOptions" :key="calc.value">
                          {{ calc.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 12 }" :xxl="{ span: 10 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0">
                    <div style="margin-right:4px;line-height:40px;display:inline-block"
                      v-if="child.valueOptionsType == 'time'">
                      <a-checkbox v-model="child.dynamic_time"
                        @change="dynamic_time => onChangeDynamicTime(dynamic_time, child)">
                        <span style="font-size:12px;">{{ $t('message.addUserGroup.DynamicTime') }}</span>
                      </a-checkbox>
                    </div>
                    <a-form-model-item style="display:inline-block"
                      v-if="child.valueOptionsType == 'time' && !child.dynamic_time"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SelectDate'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-date-picker :size="$globalSize" :show-time="{ format: 'HH:mm:ss' }"
                        :disabledDate="disabledDateRange" format="YYYY-MM-DD HH:mm:ss" style="width:60%"
                        v-if="child.calc == '等于'" v-model="child.value[0]" />
                      <a-range-picker :size="$globalSize" v-else :show-time="{
                        hideDisabledOptions: true
                      }" :disabled-date="disabledRangeTime" format="YYYY-MM-DD HH:mm:ss" v-model="child.value" :ranges="{
                        最近一周: [moment().subtract(7, 'days'), moment()],
                        最近两周: [moment().subtract(14, 'days'), moment()],
                        最近一月: [moment().subtract(1, 'months'), moment()],
                        最近三月: [moment().subtract(3, 'months'), moment()],
                        最近半年: [moment().subtract(6, 'months'), moment()],
                        最近一年: [moment().subtract(1, 'years'), moment()]
                      }" style="width: 73%;margin-left:-1%" />
                      <!-- <a-checkbox v-model="child.checked" style="margin-left:1%">
                            <span style="font-size:12px;">过滤空值</span>
                      </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item style="display:inline-block"
                      v-else-if="child.valueOptionsType == 'time' && child.dynamic_time"
                      v-bind="{ wrapperCol: { span: 24 } }">
                      <a-input-number :size="$globalSize" style="width:22%" :min="-100" v-model="child.value[0]" />
                      <a-input-number :size="$globalSize" style="margin-left:4px;width:22%;" :min="-100"
                        v-model="child.value[1]" />
                      <!-- <a-checkbox v-model="child.checked" style="margin-left:1%">
                          <span style="font-size:12px;">过滤空值</span>
                      </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'date'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SelectDate'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-date-picker :size="$globalSize" :disabledDate="disabledDateRange" format="YYYY-MM-DD"
                        style="width: 71%" v-if="child.calc == '等于'" v-model="child.value[0]" />
                      <a-range-picker :size="$globalSize" v-else :disabled-date="disabledDateRange" format="YYYY-MM-DD"
                        v-model="child.value" :ranges="{
                          最近一周: [moment().subtract(7, 'days'), moment()],
                          最近两周: [moment().subtract(14, 'days'), moment()],
                          最近一月: [moment().subtract(1, 'months'), moment()],
                          最近三月: [moment().subtract(3, 'months'), moment()],
                          最近半年: [moment().subtract(6, 'months'), moment()],
                          最近一年: [moment().subtract(1, 'years'), moment()]
                        }" style="width: 71%" />
                      <!-- <a-checkbox v-model="child.checked" style="width: 25%;margin-left:3%">
                            过滤空值
                      </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'list'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SelectTagValue'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" :mode="child.calc.includes('包含') ? 'default' : 'multiple'"
                        :default-value="child.value" v-model="child.value" :maxTagCount="maxNumInner"
                        optionFilterProp="title" style="width: 71%"
                        :getPopupContainer="(triggerNode) => { return triggerNode.parentNode }"
                        :placeholder="$t('message.addUserGroup.SelectMultipleAllowed')" @change="changeSelect">
                        <a-select-option v-for="item in child.valueOptions" :key="item.tag_val" :title="item.label">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                      <!-- <a-checkbox v-model="child.checked" style="width: 25%;margin-left:3%">
                            过滤空值
                      </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'value'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: $t('message.addUserGroup.CompletetheForm'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-input-number :size="$globalSize" class="input-number-no-icon" v-model="child.value" :min="0"
                        style="width: 71%" />
                      <!-- <a-checkbox v-model="child.checked" style="width: 25%;margin-left:3%">
                            过滤空值
                      </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'search'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: $t('message.addUserGroup.SearchTags'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" show-search v-model="child.value" mode="multiple"
                        :placeholder="$t('message.addUserGroup.EnterSearchKeywords')" style="width: 71%"
                        :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="(value) => { fetchData(value, child.tag_id) }">
                        <a-spin v-if="fetching" slot="notFoundContent" />
                        <a-select-option v-for="item in tagValueList" :key="item.tag_val" :title="item.label">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                      <!-- <a-checkbox v-model="child.checked" style="width: 25%;margin-left:3%">
                          过滤空值
                    </a-checkbox> -->
                    </a-form-model-item>
                    <a-form-model-item v-else v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.value'" :rules="{
                        required: true,
                        message: $t('message.addUserGroup.CompletetheForm'),
                        trigger: ['blur', 'change'],
                      }">
                      <a-input :size="$globalSize" placeholder='select' v-model="child.value" style="width: 71%" />
                      <!-- <a-checkbox v-model="child.checked" style="width: 25%;margin-left:3%">
                            过滤空值
                      </a-checkbox> -->
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 1 }" :xxl="{ span: 2 }">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <a-icon class="dynamic-delete-button" type="minus-circle-o"
                        @click="removeUnionDomainChild(index, childIndex)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="inner-add-filter">
                  <a-button :size="$globalSize"
                    v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition == '且')"
                    @click="addUnionDomainChild(index, 'and')">
                    {{ $t('message.addUserGroup.AndCnd') }}
                  </a-button>
                  <a-button :size="$globalSize"
                    v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition == '或')"
                    @click="addUnionDomainChild(index, 'or')">
                    {{ $t('message.addUserGroup.OrCnd') }}
                  </a-button>
                </div>
              </a-card>
            </div>
          </a-form-model>
        </div>
        <a-card class="filter-card-different" v-if="differentForm.domains.length > 0">
          <div class="different-title">
            <a-icon type="minus-circle" @click="removeDifferent" />
            <span style="margin-left: 20px">排除以下人群</span>
          </div>
          <a-form-model ref="differentForm" :model="differentForm" v-bind="formItemLayoutWithOutLabel"
            id="differentForm">
            <div v-for="(domain, index) in differentForm.domains" :style="{ marginTop: index != 0 ? '20px' : '30px' }" :key="index">
              <a-tabs class="tab-gradient" :activeKey="domain[0].apposition" v-if="index != 0"
                @change="tabDifferentChange">
                <a-tab-pane key="且" tab="AND"></a-tab-pane>
                <a-tab-pane key="或" tab="OR"></a-tab-pane>
              </a-tabs>
              <a-card :style="{ marginTop: index != 0 ? '-17px' : '0px' }">
                <div class="close-total-filter">
                  <a-icon type="close" @click="removeDifferentDomain(index)" />
                </div>
                <a-row :gutter="16" v-for="(child, childIndex) in domain" :key="child.key">
                  <a-col :md="{ span: 2 }" :xxl="{ span: 1 }" v-if="childIndex != 0">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <span style="font-size: 14px;font-weight: 500;float: right">{{
                        child.apposition == '且' ? 'AND:' : 'OR:'
                      }}</span>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 7 }" :xxl="{ span: 6 }">
                    <a-form-model-item class="filter-tag-container" v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.tag_id'" :rules="{
                        required: true,
                        message: '请选择标签',
                        trigger: ['blur', 'change'],
                      }">
                      <a-tree-select :size="$globalSize" v-model="child.tag_id" show-search style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择标签" allow-clear
                        treeNodeFilterProp="title" :tree-data="tagAll.options"
                        @change="handleDifferentChildTagChange(index, childIndex)">
                      </a-tree-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 4 }" :xxl="{ span: 3 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.calc'" :rules="{
                        required: true,
                        message: '请选择计算规则',
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" :default-value="child.calc" v-model="child.calc" style="width: 100%"
                        placeholder="请选择计算规则">
                        <a-select-option v-for="calc in child.calcOptions" :key="calc.value">
                          {{ calc.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 9 }" :xxl="{ span: 10 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0">

                    <a-form-model-item v-if="child.valueOptionsType == 'time'" v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.value'" :rules="{
                        required: true,
                        message: '请选择日期',
                        trigger: ['blur', 'change'],
                      }">
                      <a-date-picker :size="$globalSize" :show-time="{ format: 'HH:mm:ss' }"
                        :disabledDate="disabledDateRange" format="YYYY-MM-DD HH:mm:ss" style="width: 100%"
                        v-if="child.calc == '等于'" v-model="child.value[0]" />
                      <a-range-picker :size="$globalSize" v-else :show-time="{
                        hideDisabledOptions: true
                      }" :disabled-date="disabledRangeTime" format="YYYY-MM-DD HH:mm:ss" v-model="child.value" :ranges="{
                        最近一周: [moment().subtract(7, 'days'), moment()],
                        最近两周: [moment().subtract(14, 'days'), moment()],
                        最近一月: [moment().subtract(1, 'months'), moment()],
                        最近三月: [moment().subtract(3, 'months'), moment()],
                        最近半年: [moment().subtract(6, 'months'), moment()],
                        最近一年: [moment().subtract(1, 'years'), moment()]
                      }" style="width: 100%" />
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'date'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: '请选择日期',
                        trigger: ['blur', 'change'],
                      }">
                      <a-date-picker :size="$globalSize" :disabledDate="disabledDateRange" format="YYYY-MM-DD"
                        style="width: 100%" v-if="child.calc == '等于'" v-model="child.value[0]" />
                      <a-range-picker :size="$globalSize" v-else :disabled-date="disabledDateRange" format="YYYY-MM-DD"
                        v-model="child.value" :ranges="{
                          最近一周: [moment().subtract(7, 'days'), moment()],
                          最近两周: [moment().subtract(14, 'days'), moment()],
                          最近一月: [moment().subtract(1, 'months'), moment()],
                          最近三月: [moment().subtract(3, 'months'), moment()],
                          最近半年: [moment().subtract(6, 'months'), moment()],
                          最近一年: [moment().subtract(1, 'years'), moment()]
                        }" style="width: 100%" />
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'list'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: '请选择标签值',
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" :mode="child.calc.includes('包含') ? 'default' : 'multiple'"
                        :default-value="child.value" v-model="child.value" :maxTagCount="maxNumInner"
                        optionFilterProp="title" style="width: 100%" :placeholder="'请选择（可多选）'">
                        <a-select-option v-for="item in child.valueOptions" :key="item.tag_val" :title="item.label">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'value'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: '请填写完整',
                        trigger: ['blur', 'change'],
                      }">
                      <a-input-number :size="$globalSize" class="input-number-no-icon" v-model="child.value" :min="0"
                        style="width: 100%" />
                    </a-form-model-item>
                    <a-form-model-item v-else-if="child.valueOptionsType == 'search'"
                      v-bind="{ wrapperCol: { span: 24 } }" :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: '请搜索标签',
                        trigger: ['blur', 'change'],
                      }">
                      <a-select :size="$globalSize" show-search v-model="child.value" mode="multiple"
                        placeholder="请输入搜索关键字" style="width: 100%" :default-active-first-option="false"
                        :show-arrow="false" :filter-option="false" :not-found-content="fetching ? undefined : null"
                        @search="(value) => { fetchData(value, child.tag_id) }">
                        <a-spin v-if="fetching" slot="notFoundContent" />
                        <a-select-option v-for="item in tagValueList" :key="item.tag_val" :title="item.label">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item v-else v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.value'" :rules="{
                        required: true,
                        message: '请填写完整',
                        trigger: ['blur', 'change'],
                      }">
                      <a-input-number :size="$globalSize" class="input-number-no-icon" v-model="child.value" :min="0"
                        style="width: 71%" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 1 }" :xxl="{ span: 2 }">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <a-icon class="dynamic-delete-button" type="minus-circle-o"
                        @click="removeDifferentDomainChild(index, childIndex)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="inner-add-filter">
                  <a-button :size="$globalSize"
                    v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition == '且')"
                    @click="addDifferentDomainChild(index, 'and')">
                    增加AND条件
                  </a-button>
                  <a-button :size="$globalSize"
                    v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition == '或')"
                    @click="addDifferentDomainChild(index, 'or')">
                    增加OR条件
                  </a-button>
                </div>
              </a-card>
            </div>
          </a-form-model>
        </a-card>
        <div class="card-footer">
          <div class="button-div">
            <!--            <a-button  :size="$globalSize"  @click="addDifferentDomain">-->
            <!--              增加排除人群-->
            <!--            </a-button>-->
            <a-button :size="$globalSize" type="primary" @click="addUnionDomain">
              <a-icon type="plus" />
              {{ $t('message.addUserGroup.AddFilteringModule') }}
            </a-button>
            <a-button :size="$globalSize" type="primary" @click="openSaveModal" :loading="loadingSave">
              {{ $t('message.addUserGroup.PreviewandSave') }}
            </a-button>
          </div>
        </div>
      </a-card>
      <a-drawer width="800" :closable="false" :visible="drawerVisible" @close="onDrawerClose">
        <template slot="title">
          <a-tabs v-model="tagOverviewMyTag" class="tab-no-border" @change="tagOverviewMyTagChange">
            <a-tab-pane tab="全部标签" key="1"></a-tab-pane>
            <a-tab-pane tab="我的标签" key="2"></a-tab-pane>
          </a-tabs>
        </template>
        <a-row style="margin-bottom:10px;" v-if="tagOverviewMyTag == '1'">
          <a-col :span="13">
            <a-input :size="$globalSize" placeholder="请输入标签关键字" v-model.trim="searchLabelKey"></a-input>
          </a-col>
          <a-col :span="1"></a-col>
          <a-col :span="10">
          </a-col>
        </a-row>
        <a-spin :spinning="spinningLabel">
          <a-tabs v-if="tagOverviewMyTag == '1'" class="tab-gradient" default-active-key="1" v-model="tagOverviewTab">
            <!-- <a-spin :spinning="spinningLabel"> -->
            <a-tab-pane v-for="(tab, tab_index) in tabData.key" :key="(tab_index + 1)" :tab="formatTag(tab)">
              <a-collapse accordion expand-icon-position="right">
                <a-collapse-panel v-for="(group, group_index) in tabData[tab]"
                  :key="group + tab_index + '_' + group_index" :header="formatTag(group.group)">
                  <div slot="extra">
                    <div class="collapse-panel-mytitle"></div>
                  </div>
                  <a-collapse :bordered="false">
                    <a-collapse-panel v-for="(level, level_index) in group.tagList"
                      :key="group + tab_index + '_' + group_index + '_' + level_index"
                      :header="formatTag(level.type) + '(' + level.count + ')'">
                      <!-- 标签有分类 -->
                      <template v-if="level.hastype === 1">
                        <a-tabs>
                          <a-tab-pane v-for="tabNames in level.view_type" :key="tabNames" :tab="tabNames">
                            <div v-for="tag in level.children.filter(tag => (tag.view_type === tabNames))"
                              :key="tag.tag_id" style="display:inline-block">
                              <a-popover placement="topLeft">
                                <template slot="content">
                                  {{ tag_prompt }}
                                </template>
                                <!-- <a-tag class="my-tag" @click="getChartByDim(tag)"> -->
                                <a-tag class="my-tag" @mouseenter.native="getDimTagValue(tag.tag_id)">
                                  {{ tag.tag_cn }}
                                </a-tag>
                              </a-popover>
                              <a-icon @click="changeFavor(tag, true)" type="star" style="margin-right: 20px"
                                :theme="tag.favorite == 1 ? 'filled' : 'outlined'" />
                            </div>
                          </a-tab-pane>
                        </a-tabs>
                      </template>

                      <!-- 标签无分类 -->
                      <template v-else>
                        <div v-for="tag in level.children" :key="tag.tag_id" style="display: inline-block">
                          <a-popover placement="topLeft">
                            <template slot="content">
                              {{ tag_prompt }}
                            </template>
                            <!-- <a-tag class="my-tag" @click="getChartByDim(tag)"> -->
                            <a-tag class="my-tag" @mouseenter.native="getDimTagValue(tag.tag_id)">
                              {{ tag.tag_cn }}
                            </a-tag>
                          </a-popover>
                          <a-icon @click="changeFavor(tag, true)" type="star" style="margin-right: 20px"
                            :theme="tag.favorite == 1 ? 'filled' : 'outlined'" />
                        </div>
                      </template>
                    </a-collapse-panel>
                  </a-collapse>
                </a-collapse-panel>
              </a-collapse>
            </a-tab-pane>
          </a-tabs>
        </a-spin>
        <a-drawer :title="lastedTag" width="520" :closable="false" :visible="childrenDrawer"
          @close="onChildrenDrawerClose">
          <a-card>
            <div id="chartArea" style="width: 100%; height: 300px"></div>
          </a-card>
          <a-card class="box-card">
            <a-table :columns="columns" :pagination="false" :data-source="tableData" rowKey="id" border="false"
              style="margin-top: 30px">
              <template slot="count" slot-scope="text">
                <span v-text="showThousandNum(text)"></span>
              </template>
            </a-table>
          </a-card>
        </a-drawer>
        <a-card v-if="tagOverviewMyTag == '2'" style="margin-top: 5px" :bordered="false">
          <template slot="title">
            <a-input :size="$globalSize" v-model="tagTableSearchInput" placeholder="请输入关键词"
              style="width: 240px"></a-input>
            <a-tree-select :size="$globalSize" placeholder="请选择标签层级" allow-clear v-model="tagTableSearchInput1"
              style="width: 240px;margin-left:10px" :tree-data="labelFilterOption"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
          </template>
          <a-spin :spinning="spinning">
            <a-table :columns="tagTableColumns" row-key="id" :pagination="tagTablePagination" :scroll="{ x: 1300 }"
              :data-source="tagTableData.filter(tagTableFilter)">
              <template slot="dim_level_1" slot-scope="text, record">
                <span>{{ record.dim_level_1 }}/{{ record.dim_level_2 }} /{{ record.dim_level_3 }}</span>
              </template>
              <template slot="tag_sample" slot-scope="text">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <div v-if="text.toString().length >= 18">{{ text.toString() }}</div>
                  </template>
                  <div v-if="text.toString().length >= 18">{{ text.toString().substr(0, 18) }}</div>
                </a-tooltip>
                <div v-if="text.toString().length < 18">{{ text }}</div>
              </template>

              <template slot="create_time" slot-scope="text, record">
                <span>{{ showMyTagTime(record.create_time) }}</span>
              </template>

              <template slot="update_time" slot-scope="text, record">
                <span>{{ showMyTagTime(record.update_time) }}</span>
              </template>

              <template slot="favorite" slot-scope="text, record">
                <a-rate :count="1" style="font-size: 20px" :value="text" @change="changeFavor(record)" />
              </template>
            </a-table>
          </a-spin>
        </a-card>
      </a-drawer>
    </a-spin>

    <!-- 我的标签 -->
    <MyTags v-if="myTagsVisible" @destoryMyTags="destoryMyTags" @updateTags="updateTags">
    </MyTags>

  </div>
</template>

<script>
import moment from "moment";
import utils from "@/utils";
import addUserGroupService from "../../interface/pages/UserGroup/addUserGroup";
import addUserGroupServiceV2 from "@/interface/pages/UserGroup/addUserGroupV2";
import tagManagementService from "@/interface/pages/Tag/tagManagement";
import MyTags from './conponents/MyTags.vue';

let loadPopNum;
let shrink;
//标签中文值
let tag_cn = {};
let timeout;
export default {
  name: 'AddUserGroup',
  components: {
    MyTags
  },
  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 9
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 14
      },
      autoidDisable: false,
      tag_prompt: '',
      spinningBtn: false,
      searchLabelKey: null,
      spinningLabel: false,
      loadingSpin: false,
      loadingLabel: false,
      labelFilterOption: [],
      // loading
      reload: false,
      people_id_reload: false,
      // date
      dateFormat: 'YYYY/MM/DD',
      showUnionTimeRange1: false,
      showUnionTimeRange2: false,
      showUnionTimeRange3: false,
      showUnionFormOms: false,
      showUnionFormCrm: false,
      showUnionFormSensor: false,
      showDifferentTimeRange1: false,
      showDifferentTimeRange2: false,
      showDifferentTimeRange3: false,
      showDifferentFormOms: false,
      showDifferentFormCrm: false,
      showDifferentFormSensor: false,
      // filters
      unionForm: {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        domains: [
          [
            {
              apposition: "且",
              tag_id: [],
              tag_name: [],
              calc: [],
              calcOptions: [],
              value: '',
              valueOptions: [],
              key: Date.now()
            }
          ]
        ]
      },
      differentForm: {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        divHeight: 0,
        domains: [
          // [
          //   {
          //     apposition: "且",
          //     tag_id: [],
          //     calc: [],
          //     calcOptions: [],
          //     value: 0,
          //     valueOptions: [],
          //     key: Date.now()
          //   }
          // ]
        ]
      },
      tagAll: {
        children: [],
        options: []
      },
      // random
      showShrink: false,
      shrinkUser: false,
      shrinkForm: {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0
      },
      shrinkNum: 0,
      showShrinkNum: false,
      // modal
      popNum: 0,
      saveModal: false,
      saveForm: {
        group_name: "",
        group_type: "1",
        group_id: ""
      },
      saveFormRules: {
        group_name: [
          { required: true, message: this.$t('message.customGroup.FillinAudienceName'), trigger: "blur" }
        ],
        group_type: [
          { required: true, message: this.$t('message.customGroup.SelectCalculationType'), trigger: "blur" }
        ],
        autoid: [
          { required: true, message: this.$t('message.customGroup.SelectAudienceIDGenerationMethod'), trigger: "blur" }
        ],
        group_id: [
          { required: true, message: this.$t('message.customGroup.FillintheAudienceID'), trigger: "blur" }
        ]
      },
      // 标记多选框最多显示个数
      maxNumOuter: window.screen.height < 1080
        ? 1
        : window.screen.height <= 2160
          ? 3
          : 5,
      maxNumInner: window.screen.height < 1080
        ? 1
        : window.screen.height <= 2160
          ? 2
          : 4,
      // authority
      admin: false,
      // authorityButton: "",
      // formLabel
      formItemLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 15
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          md: {
            offset: 3,
            span: 2
          },
          xxl: {
            offset: 2,
            span: 1
          }
        }
      },
      formItemLayoutWithOutLabelChild: {
        wrapperCol: {
          md: {
            offset: 2,
            span: 2
          },
          xxl: {
            offset: 1,
            span: 1
          }
        }
      },
      tabList: [
        {
          key: '且',
          tab: 'AND'
        },
        {
          key: '或',
          tab: 'OR'
        }
      ],
      // drawer
      drawerVisible: false,
      // 全部标签
      tabData: {},
      childrenDrawer: false,
      tagOverviewTab: 1,
      tagOverviewMyTag: "1",
      lastedTag: "",
      columns: [
        {
          title: "分类",
          align: "center",
          dataIndex: "name",
          width: 50,
        },
        {
          title: "人数",
          align: "center",
          width: 50,
          dataIndex: "count",
          sorter: (a, b) => a.count - b.count,
          scopedSlots: { customRender: "count" },
        },
        {
          title: "人数占比",
          align: "center",
          width: 50,
          dataIndex: "precent"
        },
      ],
      tableData: [],
      disabledTags: '',
      // my tag
      tagTableColumns: [
        {
          title: "ID",
          dataIndex: "id",
          sorter: (a, b) => a.id > b.id, //排序
          width: 70,
          fixed: "left",
        },
        {
          title: "标签ID",
          dataIndex: "dim_code",
          align: "center",
          width: 240
        },
        {
          title: "标签分类",
          align: "center",
          dataIndex: "dim_type",
          width: 200,
          scopedSlots: { customRender: "dim_type" }, //格式化，需要注意的是a-table中插槽的绑定
        },
        {
          title: "标签层级",
          align: "center",
          dataIndex: "dim_level_1",
          width: 160,
          scopedSlots: { customRender: "dim_level_1" },
        },
        {
          title: "标签名",
          align: "center",
          width: 160,
          dataIndex: "dim_name_cn",
        },
        {
          title: "备注",
          align: "center",
          dataIndex: "tag_sample",
          width: 160,
          scopedSlots: { customRender: "tag_sample" },
          // width: 100
        },
        {
          title: "创建日期",
          align: "center",
          dataIndex: "create_time",
          width: 160,
          sorter: (a, b) =>
            this.string2Date(a.create_time) - this.string2Date(b.create_time),
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: "更新日期",
          align: "center",
          dataIndex: "update_time",
          width: 160
        },
        {
          title: "收藏",
          align: "center",
          dataIndex: "favorite",
          fixed: "right",
          // width: 100,
          scopedSlots: { customRender: "favorite" }, //格式化，需要注意的是a-table中插槽的绑定 
        },
      ],
      tagTablePagination: {
        position: "bottom",
        defaultPageSize:
          window.screen.height <= 800
            ? 5
            : window.screen.height <= 1080
              ? 5
              : window.screen.height <= 2160
                ? 10
                : 15, //默认当前页数据量
        showTotal: (total) => `${this.$t('message.commonUsage.total')} ${this.tagTableData.length} ${this.$t('message.commonUsage.records')}`, //数据总量
        showSizeChanger: true, //显示当前页数据量改变
        pageSizeOptions: ["5", "8", "10", "15"], //页容量显示
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
        showQuickJumper: true, //显示跳转
      },
      tagTableData: [],
      tagTableSearchInput: '',
      tagTableSearchInput1: '',
      spinning: false,
      labelType: ['微商城', 'BOX', '线下', '电商整体', '整体', '1月内', '3月内', '6月内', '12月内', '财年内', '累计实际', '默认',],
      tagValueList: [],
      fetching: false,
      myTagsVisible: false,
      audienceID: this.$route.params.group_id,
      audienceItem: {},
      loadingSave: false,
    }
  },
  mounted() {
    this.audienceID = this.$route.params.group_id;
    utils.languageChange(this, { labelCol: 9, wrapperCol: 14 }, { labelCol: 6, wrapperCol: 16 })
    this.getFilters();
    if (this.audienceID) {
      this.getDetail();
    }
    setTimeout(() => {
      this.reload = false;
    }, 1000 * 3);
  },
  methods: {
    async getDetail() {
      try {
        let body = {
          segmentId: this.audienceID,
        };

        const { data: res } = await addUserGroupService.getSegmentPackageDetail(this, { params: body })
        if (res.code == '200') {
          this.audienceItem = res.data;
          let tag_cnd = res.data.tag_cnd;
          this.saveForm.group_name = res.data.group_name;
          if (typeof tag_cnd != 'undefined' && tag_cnd.length > 3) {
            let copy_data = JSON.parse(tag_cnd);
            this.unionForm = {
              timeRange1: [],
              timeRange2: [],
              timeRange3: [],
              domains: []
            };
            this.differentForm = {
              timeRange1: [],
              timeRange2: [],
              timeRange3: [],
              domains: []
            };
            this.$nextTick(() => {
              this.unionForm = this.getDomains(copy_data["unionForm"]);
              this.differentForm = this.getDomains(copy_data["differentForm"]);
            });
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.error(error);
      }
    },
    updateTags() {
      this.getFilters()
    },
    destoryMyTags() {
      this.myTagsVisible = false
    },
    myTagsHandle() {
      this.myTagsVisible = true
    },
    onChangeDynamicTime(dynamic_time, child) {
      // console.log(child)
      child.value = []
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    getDimTagValue(tag_id) {
      let that = this
      this.tag_prompt = ''
      let body = {
        dim_code: tag_id
      };
      addUserGroupService.getDimTagValue(that, { params: body }).then(function (response) {
        let res = response.data;
        if (res.code == '200') {
          that.tag_prompt = res.obj.tag_prompt
        }
      })
    },
    fetchData(value, dim_code) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      // this.searchTagValue(value, dim_code)
      timeout = setTimeout(this.searchTagValue(value, dim_code), 300);

    },
    searchTagValue(value, dim_code) {
      this.tagValueList = []
      if (!value || !dim_code) return
      this.fetching = true
      let body = { dim_code, keyword: value };
      tagManagementService.searchTagVal(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.tagValueList = res.data
            } else {
              this.$message.error(res.message)
            }
            this.fetching = false
          }.bind(this)
        )
        .catch((response) => {
          this.fetching = false
        });
    },
    changeSelect() {
      this.$forceUpdate()
    },
    formatTag(val) {
      var tmp = tag_cn[val];
      if (tmp != null && tmp != "") {
        return tmp
      } else {
        return val;
      }
      // return val;
    },
    moment,
    // 获取下拉框的值
    getFilters() {
      this.loadingLabel = true
      this.reload = true;
      let body = {
        user_id: localStorage.getItem("userId")
      };
      addUserGroupService.tagFilters(this, { params: body }).then(function (response) {
        let res = response.data;
        if (res.code == "200") {
          const obj = res.data
          this.tagAll = obj
          this.loadingLabel = false
          // 一级二级标签禁用
          this.tagAll.options = res.data.options[0].children
          this.tagAll.options.forEach(item => {
            if (item.children.length === 0) {
              item.disabled = true
            }
          })
          setTimeout(() => {
            this.reload = false;
          }, 1000 * 3);
        }
      }.bind(this)).catch(response => {
        console.log(response);
      });
    },
    // 获取当前用户的禁用标签
    getDisabledTags() {
      let body = {};
      addUserGroupService.getDisabledTags(this, { params: body }).then(function (response) {
        let res = response.data;
        if (res.code == '200') {
          this.disabledTags = res.data;
        } else {
          this.$message.error(res.message);
        }
      }.bind(this)).catch(response => {
        console.log(response);
      })
    },
    // 增加排除人群
    addDifferentDomain() {
      let value = this.unionForm.domains[0][0].value
      if (value === 0) {
        value = true
      }
      if (value == "" || value == null) {
        this.$message.info("请先填写筛选人群");
      } else {
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0
        };
        this.showShrinkNum = false;
        this.differentForm.domains.push([{
          apposition: typeof this.differentForm.domains[0] == 'undefined'
            ? '且' : typeof this.differentForm.domains[0][0] == 'undefined'
              ? '且' : this.differentForm.domains[0][0].apposition,
          tag_id: [],
          calc: [],
          calcOptions: [],
          value: 0,
          valueOptions: [],
          timeRange: [],
          key: Date.now()
        }]);
      }
    },
    removeDifferent() {
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0
      };
      this.showShrinkNum = false;
      this.differentForm.domains = [];
    },
    removeDifferentDomain(index) {
      if (index !== -1) {
        this.differentForm.domains.splice(index, 1);
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0
        };
        this.showShrinkNum = false;
        // this.checkTagToShowTimeRange('different');
      }
    },
    // 增加筛选模块
    addUnionDomain() {
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0
      };
      this.showShrinkNum = false;
      this.unionForm.domains.push([{
        apposition: typeof this.unionForm.domains[0] == 'undefined'
          ? '且' : typeof this.unionForm.domains[0][0] == 'undefined'
            ? '且' : this.unionForm.domains[0][0].apposition,
        tag_id: [],
        calc: [],
        calcOptions: [],
        value: 0,
        valueOptions: [],
        timeRange: [],
        key: Date.now()
      }]);
    },
    removeUnionDomain(index) {
      if (index !== -1) {
        this.unionForm.domains.splice(index, 1);
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0
        };
        this.showShrinkNum = false;
        // this.checkTagToShowTimeRange('union');
      }
    },
    // union
    addUnionDomainChild(index, apposition) {
      let len = this.unionForm.domains[index].length;
      if (len > 0) {
        let tag_id = this.unionForm.domains[index][len - 1].tag_id;
        let calc = this.unionForm.domains[index][len - 1].calc;
        let value = this.unionForm.domains[index][len - 1].value;
        let dynamic_time = this.unionForm.domains[index][len - 1].dynamic_time

        if (dynamic_time) {
          if (typeof tag_id == 'undefined' || tag_id.length < 1
            || typeof calc == 'undefined' || calc.length < 1
            || typeof value == 'undefined' || value.length !== 2) {
            this.$message.info(this.$t('message.addUserGroup.CompletetheConditions'));
            return;
          }
        } else {
          if (typeof tag_id == 'undefined' || tag_id.length < 1
            || typeof calc == 'undefined' || calc.length < 1
            || typeof value == 'undefined' || value.length < 1) {
            this.$message.info(this.$t('message.addUserGroup.CompletetheConditions'));
            return;
          }
        }
      }
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0
      };
      this.showShrinkNum = false;
      this.unionForm.domains[index].push({
        apposition: apposition == "and" ? "且" : "或",
        tag_id: [],
        calc: [],
        calcOptions: [],
        value: 0,
        valueOptions: [],
        key: Date.now(),
      });
    },
    removeUnionDomainChild(index, childIndex) {
      if (index !== -1) {
        if (this.unionForm.domains[index].length == 1) {
          this.unionForm.domains.splice(index, 1);
        } else {
          this.unionForm.domains[index].splice(childIndex, 1);
        }
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0
        };
        this.showShrinkNum = false;
        // this.checkTagToShowTimeRange('union');
      }
    },
    handleUnionChildTagChange(index, childIndex) {
      let name = 'domains.' + index + '.' + childIndex + '.' + 'tag_name'
      this.$refs.unionForm.validateField(name)
      this.unionForm.domains[index][childIndex].valueOptions = [];
      this.unionForm.domains[index][childIndex].value = ''
      let that = this
      // this.checkTagToShowTimeRange('union');
      console.log(this.unionForm.domains[index][childIndex])
      console.log(this.unionForm.domains[index][childIndex].tag_name)
      let tag_name = this.unionForm.domains[index][childIndex].tag_name
      this.unionForm.domains[index][childIndex].tag_id = tag_name[tag_name.length - 1]
      let tag_id = tag_name[tag_name.length - 1]

      if (tag_id == null || tag_id.length < 1) {
        return;
      }
      // let valueOptions = this.tagAll.children[tag_id.substring(2, tag_id.length)];
      console.log(tag_id)
      console.log(this.tagAll.children)
      let valueOptions = this.tagAll.children[tag_id];
      let valueOptionsType = valueOptions.type; //类型
      if (valueOptionsType == 'value') {
        that.unionForm.domains[index][childIndex].valueOptions = [];
        that.unionForm.domains[index][childIndex].value = ''
      } else if (valueOptionsType == 'search') {
        that.unionForm.domains[index][childIndex].valueOptions = [];
        that.unionForm.domains[index][childIndex].value = undefined;
        that.tagValueList = []
      } else {
        if (valueOptionsType == 'list') {
          that.unionForm.domains[index][childIndex].value = undefined;
        }
        let body = {
          dim_code: tag_id
        };
        addUserGroupService.getDimTagValue(that, { params: body }).then(function (response) {
          let res = response.data;
          if (res.code == '200') {
            that.unionForm.domains[index][childIndex].keyword = res.obj.isKeyword
            that.unionForm.domains[index][childIndex].valueOptions = res.data;
            that.unionForm.domains[index][childIndex].value = [];
            if (valueOptionsType == 'list') {
              that.unionForm.domains[index][childIndex].value = undefined;
            }
          } else {

          }
        })
      }
      this.unionForm.domains[index][childIndex].valueOptionsType = valueOptions.type;
      this.handleUnionChildCalcChange(index, childIndex, valueOptions);
    },
    handleUnionChildCalcChange(index, childIndex, selectValueOptions) {
      this.unionForm.domains[index][childIndex].calcOptions = [];
      // let valueOptions = this.unionForm.domains[index][childIndex].valueOptions;
      if (selectValueOptions.type == 'value') {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "大于",
            label: this.$t('message.addUserGroup.GreaterThan')
          },
          {
            value: "大于等于",
            label: this.$t('message.addUserGroup.GreaterThanOrEqualTo')
          },
          {
            value: "小于",
            label: this.$t('message.addUserGroup.LessThan')
          },
          {
            value: "小于等于",
            label: this.$t('message.addUserGroup.LessThanOrEqualTo')
          }
        ];
      } else if (selectValueOptions.type == 'time') {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "在区间",
            label: this.$t('message.addUserGroup.InInterval')
          }
        ];
        this.unionForm.domains[index][childIndex].value = []
      } else if (selectValueOptions.type == 'date') {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "在区间",
            label: this.$t('message.addUserGroup.InInterval')
          }
        ];
        this.unionForm.domains[index][childIndex].value = []
      } else if (selectValueOptions.type == 'list') {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "不等于",
            label: this.$t('message.addUserGroup.NotEqualTo')
          },
        ];
      } else {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          }
        ];
      }
      this.unionForm.domains[index][childIndex].calc = [];
    },
    checkUnionTags(val1, val2) {
      return false;
    },
    // diff
    addDifferentDomainChild(index, apposition) {
      let len = this.differentForm.domains[index].length;
      if (len > 0) {
        let tag_id = this.differentForm.domains[index][len - 1].tag_id;
        let calc = this.differentForm.domains[index][len - 1].calc;
        let value = this.differentForm.domains[index][len - 1].value;
        if (typeof tag_id == 'undefined' || tag_id.length < 1
          || typeof calc == 'undefined' || calc.length < 1
          || typeof value == 'undefined' || value.length < 1) {
          this.$message.info(this.$t('message.addUserGroup.CompletetheConditions'));
          return;
        }
      }
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0
      };
      this.showShrinkNum = false;
      this.differentForm.domains[index].push({
        apposition: apposition == "and" ? "且" : "或",
        tag_id: [],
        calc: [],
        calcOptions: [],
        value: 0,
        valueOptions: [],
        key: Date.now(),
      });
    },
    removeDifferentDomainChild(index, childIndex) {
      if (index !== -1) {
        if (this.differentForm.domains[index].length == 1) {
          this.differentForm.domains.splice(index, 1);
        } else {
          this.differentForm.domains[index].splice(childIndex, 1);
        }
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0
        };
        this.showShrinkNum = false;
        // this.checkTagToShowTimeRange('different');
      }
    },
    handleDifferentChildTagChange(index, childIndex) {
      // this.checkTagToShowTimeRange('different');
      let tag_id = this.differentForm.domains[index][childIndex].tag_id;
      if (tag_id == null || tag_id.length < 1) {
        return;
      }
      this.differentForm.domains[index][childIndex].valueOptions = [];
      this.differentForm.domains[index][childIndex].value = ''
      let that = this
      // let valueOptions = this.tagAll.children[tag_id.substring(2, tag_id.length)];
      let valueOptions = this.tagAll.children[tag_id];
      let valueOptionsType = valueOptions.type; //类型
      if (valueOptionsType == 'value') {
        that.differentForm.domains[index][childIndex].valueOptions = [];
        that.differentForm.domains[index][childIndex].value = ''
      } else if (valueOptionsType == 'search') {
        that.differentForm.domains[index][childIndex].valueOptions = [];
        that.differentForm.domains[index][childIndex].value = undefined;
        that.tagValueList = []
      } else {
        let body = {
          dim_code: tag_id
        };
        addUserGroupService.getDimTagValue(that, { params: body }).then(function (response) {
          let res = response.data;
          if (res.code == '200') {
            that.differentForm.domains[index][childIndex].keyword = res.obj.isKeyword
            that.differentForm.domains[index][childIndex].valueOptions = res.data;
            that.differentForm.domains[index][childIndex].value = [];
          }
        })
      }
      this.differentForm.domains[index][childIndex].valueOptionsType = valueOptions.type;
      this.handleDifferentChildCalcChange(index, childIndex, valueOptions);
    },
    handleDifferentChildCalcChange(index, childIndex, selectValueOptions) {
      this.differentForm.domains[index][childIndex].calcOptions = [];
      if (selectValueOptions.type == 'value') {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "大于",
            label: this.$t('message.addUserGroup.GreaterThan')
          },
          {
            value: "大于等于",
            label: this.$t('message.addUserGroup.GreaterThanOrEqualTo')
          },
          {
            value: "小于",
            label: this.$t('message.addUserGroup.LessThan')
          },
          {
            value: "小于等于",
            label: this.$t('message.addUserGroup.LessThanOrEqualTo')
          }
        ];
      } else if (selectValueOptions.type == 'time') {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "在区间",
            label: this.$t('message.addUserGroup.InInterval')
          }
        ];
      } else if (selectValueOptions.type == 'date') {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "在区间",
            label: this.$t('message.addUserGroup.InInterval')
          }
        ];
      } else if (selectValueOptions.type == 'list') {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "不等于",
            label: this.$t('message.addUserGroup.NotEqualTo')
          },
        ];
      } else {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          }
        ];
      }
      this.differentForm.domains[index][childIndex].calc = [];
    },
    checkDifferentTags(val1, val2) {
      return false;
    },
    // 检测所选标签,控制时间框的显示与隐藏
    checkTagToShowTimeRange(type) {
      if (type == 'union') {
        this.showUnionFormOms = false;
        this.showUnionFormCrm = false;
        this.showUnionFormSensor = false;
        for (let i = 0; i < this.unionForm.domains.length; i++) {
          for (let j = 0; j < this.unionForm.domains[i].length; j++) {
            let tag_id = this.unionForm.domains[i][j].tag_id;
            if (typeof tag_id == 'undefined' || tag_id.length < 1) {
              continue;
            }
            // 时间框的显示与隐藏
            let limit_index = tag_id.indexOf("_");
            let limit = tag_id.substring(0, limit_index);
            if (limit == '1') {
              this.showUnionFormOms = true;
            }
            if (limit == '2') {
              this.showUnionFormCrm = true;
            }
            if (limit == '3') {
              this.showUnionFormSensor = true;
            }
          }
        }
        if (!this.showUnionFormOms) {
          this.unionForm.timeRange1 = [];
        }
        if (!this.showUnionFormCrm) {
          this.unionForm.timeRange2 = [];
        }
        if (!this.showUnionFormSensor) {
          this.unionForm.timeRange3 = [];
        }
      } else {
        this.showDifferentFormOms = false;
        this.showDifferentFormCrm = false;
        this.showDifferentFormSensor = false;
        for (let i = 0; i < this.differentForm.domains.length; i++) {
          for (let j = 0; j < this.differentForm.domains[i].length; j++) {
            let tag_id = this.differentForm.domains[i][j].tag_id;
            if (typeof tag_id == 'undefined' || tag_id.length < 1) {
              continue;
            }
            // 时间框的显示与隐藏
            let limit_index = tag_id.indexOf("_");
            let limit = tag_id.substring(0, limit_index);
            if (limit == '1') {
              this.showDifferentFormOms = true;
            }
            if (limit == '2') {
              this.showDifferentFormCrm = true;
            }
            if (limit == '3') {
              this.showDifferentFormSensor = true;
            }
          }
        }
        if (!this.showDifferentFormOms) {
          this.differentForm.timeRange1 = [];
        }
        if (!this.showDifferentFormCrm) {
          this.differentForm.timeRange2 = [];
        }
        if (!this.showDifferentFormSensor) {
          this.differentForm.timeRange3 = [];
        }
      }
    },
    // 多选框选中/取消选中触发
    shrinkPopulation(e) {
      let unionFormValid = true;
      if (this.unionForm.domains.length > 0) {
        unionFormValid = false;
        this.$refs.unionForm.validate(valid => {
          if (valid) {
            unionFormValid = true;
          }
        });
      }
      let differentFormValid = true;
      if (this.differentForm.domains.length > 0) {
        differentFormValid = false;
        this.$refs.differentForm.validate(valid => {
          if (valid) {
            differentFormValid = true;
          }
        });
      }
      if (!unionFormValid || !differentFormValid) {
        this.$message.error(this.$t('message.addUserGroup.CompletetheConditions'));
        this.showShrink = false;
        return;
      }
      let disabled_flag = this.disabledTest();
      if (!disabled_flag) {
        this.$message.error(this.$t('message.addUserGroup.tip1'));
        this.showShrink = false;
        return;
      }
      let checked = e.target.checked;
      if (checked) {
        // this.loadPopulation();
        this.showShrink = checked;
        this.shrinkUser = this.showShrink;
        this.shrinkForm.shrink_user_num = loadPopNum;
      }
    },
    shrinkSlideFormatter(value) {
      if (this.shrinkForm.shrink_switch) {
        return `随机抽取${value}%`;
      } else {
        return `随机抽取${value}倍`;
      }
    },
    shrinkSwitchChange(value) {
      this.shrinkForm.shrink_slide = 10;
      let num_tmp = String(this.shrinkForm.shrink_user_num / 10);
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp);
      this.shrinkForm.shrink_input = this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input;
    },
    shrinkSlideChange(value) {
      let num_tmp = String(this.shrinkForm.shrink_slide * this.shrinkForm.shrink_user_num / 100);
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp);
      this.shrinkForm.shrink_input = this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input;
    },
    shrinkUserOk() {
      this.shrinkUser = false;
      this.showShrinkNum = true;
      this.shrinkForm.shrink_input = this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input;
      this.shrinkNum = this.shrinkForm.shrink_user_num < this.shrinkForm.shrink_input ? this.shrinkForm.shrink_user_num : this.shrinkForm.shrink_input;
      shrink = this.shrinkNum;
    },
    shrinkUserCancel() {
      this.shrinkUser = false;
      this.showShrink = false;
    },
    // card-tab切换
    tabUnionChange(val) {
      let len = this.unionForm.domains.length;
      for (let i = 0; i < len; i++) {
        this.unionForm.domains[i][0].apposition = val;
      }
    },
    tabDifferentChange(val) {
      let len = this.differentForm.domains.length;
      for (let i = 0; i < len; i++) {
        this.differentForm.domains[i][0].apposition = val;
      }
    },
    // 生成es表达式
    getCalc() {
      let calc2 = {
        filterAndOr: true, // 筛选人群是 and => true or => fasle
        filters: [
          {
            andOr: true,
            filter: [
              // {
              //    condition: true,// 操作符号 （等于、大于、大于等于、不等于）
              //     dimValue: ["1-3个月" ], //标签值
              //     dim: "m_baby_age_group"  // 标签
              // }
            ]
          }
        ],
      }
      if (this.unionForm.domains.length > 0) {
        console.log(this.unionForm)
        for (let i = 0; i < 1; i++) {
          for (let j = 0; j < this.unionForm.domains[i].length; j++) {
            let filterAndOr = this.unionForm.domains[i].length > 1 ? this.unionForm.domains[i][1].apposition : this.unionForm.domains[i][0].apposition;
            let AndOr = filterAndOr === '且' ? true : false
            calc2.filterAndOr = true
            calc2.filters[0].andOr = AndOr
            let unionFormij = this.unionForm.domains[i][j]
            // 操作符
            let calc = unionFormij.calc;
            let condition = ""
            switch (calc) {
              case '等于':
                condition = 'EQUAL'
                break;
              case '不等于':
                condition = 'UNEQUAL'
                break;
              case '大于等于':
                condition = 'GREATER_EQUAL'
                break;
              case '大于':
                condition = 'GREATER'
                break;
              case '小于等于':
                condition = 'LESS_EQUAL'
                break;
              case '小于':
                condition = 'LESS'
                break;
              case '在区间':
                condition = 'IN_INTERVAL'
                break;
            }
            console.log(unionFormij)
            let dim = unionFormij.tag_id;
            let type = unionFormij.valueOptionsType;
            let value = unionFormij.value
            let dimValue = undefined
            let dynamic_time = unionFormij.dynamic_time
            if (type === 'time' && condition === "IN_INTERVAL") {
              dimValue = []
              if (dynamic_time) {
                dimValue[0] = value[0]
                dimValue[1] = value[1]
              } else {
                dimValue[0] = this.showTime(value[0]._d || value[0])
                dimValue[1] = this.showTime(value[1]._d || value[1])
              }

            } else if (type === 'time' && condition === "EQUAL") {
              dimValue = []
              dimValue[0] = this.showTime(value[0]._d || value[0])
            } else if (type === 'list' || type === 'search') {
              dimValue = value
            } else if (type === 'value') {
              dimValue = []
              dimValue[0] = value
            } else if (type === 'date' && condition === "EQUAL") {
              dimValue = []
              dimValue[0] = this.showTime(value[0]._d || value[0])
            } else if (type === 'date' && condition === "IN_INTERVAL") {
              dimValue = []
              dimValue[0] = this.showTime(value[0]._d || value[0])
              dimValue[1] = this.showTime(value[1]._d || value[1])
            } else {
              dimValue = []
              dimValue[0] = value
            }
            calc2.filters[0].filter.push({
              condition,
              dim,
              dimValue
            })
          }
        }
        if (this.unionForm.domains.length >= 2) {
          let filterAndOr2 = this.unionForm.domains[1][0].apposition
          let AndOr2 = filterAndOr2 === '且' ? true : false
          calc2.filterAndOr = AndOr2
          for (let i = 1; i < this.unionForm.domains.length; i++) {
            calc2.filters[i] = {}
            calc2.filters[i].filter = []
            for (let j = 0; j < this.unionForm.domains[i].length; j++) {
              let filterAndOr = this.unionForm.domains[i].length > 1 ? this.unionForm.domains[i][1].apposition : this.unionForm.domains[i][0].apposition;
              let AndOr = filterAndOr === '且' ? true : false
              calc2.filters[i].andOr = AndOr
              let unionFormij = this.unionForm.domains[i][j]
              // 操作符
              let calc = unionFormij.calc;
              let condition = ""
              switch (calc) {
                case '等于':
                  condition = 'EQUAL'
                  break;
                case '不等于':
                  condition = 'UNEQUAL'
                  break;
                case '大于等于':
                  condition = 'GREATER_EQUAL'
                  break;
                case '大于':
                  condition = 'GREATER'
                  break;
                case '小于等于':
                  condition = 'LESS_EQUAL'
                  break;
                case '小于':
                  condition = 'LESS'
                  break;
                case '在区间':
                  condition = 'IN_INTERVAL'
                  break;
              }
              let dim = unionFormij.tag_id;
              let type = unionFormij.valueOptionsType;
              let value = unionFormij.value
              let dimValue = undefined
              let dynamic_time = unionFormij.dynamic_time
              if (type === 'time' && condition === "IN_INTERVAL") {
                dimValue = []
                if (dynamic_time) {
                  dimValue[0] = value[0]
                  dimValue[1] = value[1]
                } else {
                  dimValue[0] = this.showTime(value[0]._d || value[0])
                  dimValue[1] = this.showTime(value[1]._d || value[1])
                }
              } else if (type === 'time' && condition === "EQUAL") {
                dimValue = []
                dimValue[0] = this.showTime(value[0]._d || value[0])
              } else if (type === 'list' || type === 'search') {
                dimValue = value
              } else if (type === 'value') {
                dimValue = []
                dimValue[0] = value
              } else if (type === 'date' && condition === "EQUAL") {
                dimValue = []
                dimValue[0] = this.showTime(value[0]._d || value[0])
              } else if (type === 'date' && condition === "IN_INTERVAL") {
                dimValue = []
                dimValue[0] = this.showTime(value[0]._d || value[0])
                dimValue[1] = this.showTime(value[1]._d || value[1])
              } else {
                dimValue = []
                dimValue[0] = value
              }
              calc2.filters[i].filter.push({
                condition,
                dim,
                dimValue
              })
            }
          }
        }
      }
      return calc2;
    },
    // 查询人群人数
    async loadPopulation() {
      // this.time_range = "";
      this.popNum = 0;
      this.loadingSpin = true;
      let unionFormValid = true;
      if (this.unionForm.domains.length > 0) {
        unionFormValid = false;
        this.$refs.unionForm.validate(valid => {
          if (valid) {
            unionFormValid = true;
          }
        });
      }
      let differentFormValid = true;
      if (this.differentForm.domains.length > 0) {
        differentFormValid = false;
        this.$refs.differentForm.validate(valid => {
          if (valid) {
            differentFormValid = true;
          }
        });
      }
      if (!unionFormValid || !differentFormValid) {
        this.$message.error(this.$t('message.addUserGroup.CompletetheConditions'));
        return;
      }

      let calc = this.getCalc();
      this.reload = true;

      if (this.showShrink && this.showShrinkNum) {
        this.popNum = this.shrinkNum;
        setTimeout(() => {
          this.reload = false;
        }, 1200);
        return;
      }

      try {
        let body = {
          // calc: JSON.stringify(calc),
          // time_range:this.time_range.toString()
          ...calc
        };
        const { data: res } = await addUserGroupServiceV2.loadPopulationSize(this, { data: body })
        if (res.code == '200') {
          this.popNum = res.data;
          loadPopNum = res.data;
          this.shrinkForm.shrink_user_num = res.data;
          let num_tmp = String(this.shrinkForm.shrink_user_num / 10);
          if (num_tmp.indexOf(".") >= 0) {
            num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
          }
          this.shrinkForm.shrink_input = Number(num_tmp);
          this.shrinkForm.shrink_input = this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input;
          setTimeout(() => {
            this.reload = false;
            this.loadingSpin = false;
            this.$message.success(this.$t('message.customGroup.TheTotalAudienceCountIs') + this.showThousandNum(this.popNum) + this.$t('message.customGroup.people'))
          }, 300);
        }
        this.loadingSave = false;
      } catch (e) {
        console.log(e)
        this.loadingSave = false;
      }
      this.reload = false;
      // this.loadingSpin = false;
    },
    disabledTest() {
      return true;
    },
    // 保存Modal
    async openSaveModal() {
      if (this.unionForm.domains.length == 0) {
        this.$message.error(this.$t('message.addUserGroup.AddFilteringModule'));
      } else {
        try {
          this.loadinSave = true;
          this.loadingSave = true;
          this.spinningBtn = false
          let unionFormValid = true;
          if (this.unionForm.domains.length > 0) {
            unionFormValid = false;
            this.$refs.unionForm.validate(valid => {
              if (valid) {
                unionFormValid = true;
              }
            });
          }
          let differentFormValid = true;
          if (this.differentForm.domains.length > 0) {
            differentFormValid = false;
            this.$refs.differentForm.validate(valid => {
              if (valid) {
                differentFormValid = true;
              }
            });
          }
          if (!unionFormValid || !differentFormValid) {
            this.$message.error(this.$t('message.addUserGroup.CompletetheConditions'));
            return;
          }

          let disabled_flag = this.disabledTest();
          if (!disabled_flag) {
            this.$message.error(this.$t('message.addUserGroup.tip1'));
            return;
          }

          // 预览并保存 直接出人数 并且加遮罩
          this.loadPopulation().then(() => {
            this.saveForm = {
              group_name: this.audienceItem.group_name,
              group_type: this.audienceItem.group_type||'1',
              group_id: this.audienceID,
              autoid: 1
            };
            // setTimeout(() => {
            //     this.$refs.saveForm.resetFields();
            // }, 20);
            this.$nextTick(() => {
              this.saveModal = true;
            })
            // this.saveForm.autoid = 1
            if (this.saveForm.group_name) {
              this.saveForm.autoid = 0
              this.autoidDisable = true
              this.people_id_reload = true
            } else {
              this.people_id_reload = false
              this.saveForm.autoid = 1
              this.autoidDisable = false
            }
          });

        } catch (e) {
          console.log(e)
          this.loadingSave = false;
        }
      }
    },
    saveBtn() {
      this.$refs.saveForm.validate(valid => {
        if (valid) {
          this.spinningBtn = true
          if (!this.admin && this.saveForm.group_type == 2 && this.popNum > 2000000) {
            this.$message.info("为保证系统资源，大于200万的人群保存为静态人群请联系系统管理员！");
            return;
          }
          // this.reload = true;
          // this.saveModal = false;
          let user_count = this.popNum;
          let tmp = {
            unionForm: this.unionForm,
            differentForm: this.differentForm
          };
          if (this.showShrink) {
            tmp.random_count = this.shrinkNum;
            user_count = this.shrinkNum;
          }
          let tag_cnd = this.audienceItem.tag_cnd;
          let upd = this.audienceID == undefined ? 0 : 1;
          let userGroupIds = this.audienceID

          // 新增 tag_cnd userGroupIds 都是undefined upd: 0
          // 修改 tag_cnd 是内容对象 userGroupIds 都是id upd: 1
          // 复制 tag_cnd 是内容对象 userGroupIds 是空upd: 1
          if (!userGroupIds && tag_cnd) {
            upd = 0
          }
          var new_group_id = ''
          if (this.audienceID) {
            new_group_id = this.audienceID
          } else {
            new_group_id = this.saveForm.group_id
          }
          let body = {
            group_id: new_group_id,
            upd,
            autoid: this.saveForm.autoid,
            group_name: this.saveForm.group_name,
            user_count: user_count,
            calc_type: this.saveForm.group_type,
            filter_group: JSON.stringify(this.getCalc()),
            tag_cnd: JSON.stringify(tmp),
            op_type: typeof tag_cnd != 'undefined' ? '复制' : this.showShrink ? '随机' : '新建',
            loginId: localStorage.getItem('userId')
          };
          addUserGroupServiceV2.addUserGroup(this, { data: body }).then(function (response) {
            let res = response.data;
            if (res.code == '200') {
              this.$message.info(res.message);
              this.$store.dispatch('fetchButtonPermission')
              setTimeout(() => {
                this.saveModal = false;
                const newPath = this.$router.resolve({
                  path: '/dataAnalysis/userAnalysis',
                  query: {
                    group_id: res.data,
                    oms_time_range: this.unionForm.timeRange1,
                    crm_time_range: this.unionForm.timeRange2,
                    sensor_time_range: this.unionForm.timeRange3,
                  }
                });
                this.$router.push({
                  path: '/audience/userGroupList'
                });
                // if (this.saveForm.group_type == '动态') {
                //     window.open(newPath.href, "_blank");
                // }
              }, 600)
            } else if (res.code == '600') {//警告提示
              this.$message.warning(res.message);
            } else {
              this.$message.error(res.message);
            }
            this.spinningBtn = false
          }.bind(this)).catch(response => {
            this.spinningBtn = false
          })
        } else {
          return false
        }
      });
    },
    closeSaveModal() {
      this.$refs.saveForm.resetFields();
      this.saveModal = false;
    },
    // 时间格式化
    showTime(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    showTime2(value) {
      return utils.formatDate(value, "yyyy-MM-dd hh:mm:ss");
    },
    // 数字的千位分隔符
    showThousandNum(value) {
      return utils.showThousandNumber(value)
    },
    // 格式化复制人群时的数据
    getDomains(form) {
      let union_length = form.domains.length;
      if (typeof form.timeRange1[0] != 'undefined' && form.timeRange1[0].length > 10) {
        let range1_start = moment(new Date(form.timeRange1[0].substring(0, 10)));
        let range1_end = moment(new Date(form.timeRange1[1].substring(0, 10)));
        form.timeRange1 = [range1_start, range1_end];
      }
      if (typeof form.timeRange2[0] != 'undefined' && form.timeRange2[0].length > 10) {
        let range2_start = moment(new Date(form.timeRange2[0].substring(0, 10)));
        let range2_end = moment(new Date(form.timeRange2[1].substring(0, 10)));
        form.timeRange2 = [range2_start, range2_end];
      }
      if (typeof form.timeRange3[0] != 'undefined' && form.timeRange3[0].length > 10) {
        let range3_start = moment(new Date(form.timeRange3[0].substring(0, 10)));
        let range3_end = moment(new Date(form.timeRange3[1].substring(0, 10)));
        form.timeRange3 = [range3_start, range3_end];
      }
      for (let i = 0; i < union_length; i++) {
        let union_child_length = form.domains[i].length;
        for (let ch_inx = 0; ch_inx < union_child_length; ch_inx++) {
          let child_valueOptions = form.domains[i][ch_inx].valueOptions;
          let child_value = form.domains[i][ch_inx].value;
          if (typeof child_valueOptions[0] != 'undefined' && child_valueOptions[0].label == 'time') {
            form.domains[i][ch_inx].value = [moment(new Date(child_value[0].substring(0, 10))), moment(new Date(child_value[1].substring(0, 10)))];
          }
        }
      }


      return form;
    },
    // 时间选择器禁用时间
    disabledDateRange(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start > end) {
        return true;
      }
      return false;
    },
    disabledRangeTime(current) {
      return current && current > moment().endOf('day');
    },
    // 筛选模块oms时间框禁用范围
    unionOmsDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange1.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange1[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionOmsDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange1[0] = dates[0];
      }
    },
    // 筛选模块crm时间框禁用范围
    unionCrmDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange2.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange2[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionCrmDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange2[0] = dates[0];
      }
    },
    // 筛选模块sensor时间框禁用范围
    unionSensorDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let pre_start = moment(new Date).subtract(180, "days");
      let pre_start_tmp = utils.formatDate(pre_start._d, "yyyyMMdd");
      if (this.admin) {
        pre_start_tmp = 20200301;
      }
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < pre_start_tmp) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange3.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange3[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < pre_start_tmp ? pre_start_tmp : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionSensorDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange3[0] = dates[0];
      }
    },
    // 排除模块oms时间框禁用范围
    differentOmsDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange1.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange1[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentOmsDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange1[0] = dates[0];
      }
    },
    // 排除模块crm时间框禁用范围
    differentCrmDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange2.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange2[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentCrmDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange2[0] = dates[0];
      }
    },
    // 排除模块sensor时间框禁用范围
    differentSensorDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let pre_start = moment(new Date).subtract(180, "days");
      let pre_start_tmp = utils.formatDate(pre_start._d, "yyyyMMdd");
      if (this.admin) {
        pre_start_tmp = 20200301;
      }
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < pre_start_tmp) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange3.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange3[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < pre_start_tmp ? pre_start_tmp : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentSensorDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange3[0] = dates[0];
      }
    },
    // drawer
    tagOverviewMyTagChange(value) {
      this.tagTableSearchInput = '';
      this.tagTableSearchInput1 = undefined
      this.getTagTreeMenu();
    },
    // getTagsOverview() {
    //     this.spinningLabel = true
    //     let body = {
    //         user_id: this.searchLabelKey
    //     };
    //     tagsOverviewService.getTagMapTree(this, {params: body}).then(function (response) {
    //         let res = response.data;
    //         if (res.code == '200') {
    //             this.tabData = res.data;
    //             for(let key in this.tabData){
    //                 if(key!=="key") {
    //                    this.tabData[key][0].tagList.forEach(ele=>{
    //                         let label = []
    //                         if(ele.hastype) {
    //                            ele.children.forEach(labitem=>{
    //                                 label.push(labitem.view_type)
    //                            })
    //                         }
    //                         // console.log(Array.from(new Set(label)))
    //                         ele.view_type = Array.from(new Set(label))
    //                    })
    //                 }
    //             }
    //         } else {
    //             this.$message.error("查询标签概览数据失败！")
    //         }
    //         this.spinningLabel = false
    //     }.bind(this)).catch(response => {
    //         console.log(response);
    //         this.spinningLabel = false
    //     });
    // },
    openDrawer() {
      this.drawerVisible = true;
    },
    onDrawerClose() {
      this.drawerVisible = false;
    },
    changeFavor(record, value) {
      if (value) {
        record.dim_code = record.tag_id
      }
      var that = this;
      if (record.favorite == 1) {
        that.$confirm({
          title: '确定取消收藏该标签吗 ?',
          okText: '确定',
          content: '此操作将会把标签移出我的收藏列表',
          cancelText: '取消',
          onOk() {
            //发请求修改
            return new Promise((resolve, reject) => {
              that.updFavorTag(record, resolve);
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {
          },
          class: 'test',
        });
      } else {
        //发请求修改
        that.updFavorTag(record);
      }
    },
    updFavorTag(record, resolve = () => { }) {
      let body = {
        tag_id: record.dim_code,
        favorite: record.favorite == 0 ? 1 : 0
      };
      tagManagementService.updFavorTag(this, { data: body }).then(
        function (response) {
          let res = response.data;
          if (res.code == "200") {
            this.$message.success(res.message, 1);
            resolve()
            this.getTagsOverview();
            this.getFilters();
            this.getFavorTag();
          } else {
            this.$message.error(res.message, 1);
          }
        }.bind(this)
      ).catch((response) => {
        console.log(response);
      });
    },
    openChildrenDrawer(tag) {
      this.lastedTag = tag.tag_cn + "(" + tag.tag_id + ")";
      this.childrenDrawer = true;

      //不显示0的数据
      var zeroIndex = tag.summary.title.indexOf('0');
      if (zeroIndex > -1) {
        tag.summary.title.splice(zeroIndex, 1);
        tag.summary.bar_data.splice(zeroIndex, 1);
        tag.summary.pie_data.splice(zeroIndex, 1);
      }
      if (tag.is_display_unknown == 0) {
        //不显示未知
        var unknownIndex = tag.summary.title.indexOf('未知');
        if (unknownIndex > -1) {
          tag.summary.title.splice(unknownIndex, 1);
          tag.summary.bar_data.splice(unknownIndex, 1);
          tag.summary.pie_data.splice(unknownIndex, 1);
        }
      } else {
        //显示未知
      }
      setTimeout(() => {
        if (typeof (tag.chart_type) == "undefined" || tag.chart_type == null || tag.chart_type == '' || tag.chart_type == 'null' || tag.chart_type == 'bar') {
          this.drawEchartsBar(tag);
        } else {
          this.drawEchartsPie(tag);
        }
        this.tableData = tag.summary.table_data;
      }, 10);
    },
    onChildrenDrawerClose() {
      this.childrenDrawer = false;
    },
    drawEchartsPie(tag) {
      let chartdata = tag.summary;
      let title = tag.tag_name;
      let myChart = this.$echarts.init(document.getElementById("chartArea"));

      let option = {
        title: {
          text: title,

          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: chartdata.title
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: chartdata.pie_data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart.resize();
      myChart.setOption(option, true);
    },
    drawEchartsBar(tag) {
      let chartdata = tag.summary;
      let title = tag.tag_name;
      let myChart = this.$echarts.init(document.getElementById("chartArea"));

      var data = [45, 390, 340, 334, 390, 92, 66, 19];
      if (chartdata.length > 0) {
        data = chartdata.bar_data;
      }
      let option = {
        title: {
          text: title,

          left: 'center'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        color: ['#336699', '#CC3333', '#CCCCCC'],
        legend: {
          data: chartdata.title,
        },
        toolbox: {
          show: true,
          feature: {
            // dataZoom: {
            //     yAxisIndex: 'none'
            // }, //区域缩放，区域缩放还原
            // dataView: {
            //     readOnly: false
            // }, //数据视图
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图

            saveAsImage: {}, //保存为图片
          },
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            splitLine: {
              show: false,
            },
            type: "category",
            data: chartdata.title,
          },
        ],
        yAxis: [
          {
            splitLine: {
              show: false,
            },
            type: "value",
          },
        ],
        series: [

          {
            name: "群体个数",
            type: "bar",
            barWidth: "60%",
            data: chartdata.bar_data,
          },
        ],
      };
      myChart.resize();
      myChart.setOption(option, true);
    },
    // 我的标签过滤
    tagTableFilter(tag) {
      if (this.tagTableSearchInput1) {
        return (tag.id.toString().toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_code.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_type.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_1.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_2.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_name_cn.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.tag_sample.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_3.toLowerCase().includes(this.tagTableSearchInput.toLowerCase()))
          && tag.dim_level_3 === this.tagTableSearchInput1;
      } else {
        return tag.id.toString().toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_code.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_type.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_1.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_2.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_name_cn.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.tag_sample.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
          || tag.dim_level_3.toLowerCase().includes(this.tagTableSearchInput.toLowerCase())
      }
    },
    // 我的标签表格数据
    getFavorTag() {
      this.spinning = true;
      let body = {};
      tagManagementService
        .getFavorTag(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.tagTableData = res.data;
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
      setTimeout(() => {
        this.spinning = false;
      }, 700);
    },
    getChartByDim(tag) {
      let body = { tag_id: tag.tag_id };
      tagManagementService.getChartByDim(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              let tagContent = {}
              tagContent.summary = res.data
              tagContent.tag_id = tag.tag_id
              tagContent.tag_cn = tag.tag_cn
              this.openChildrenDrawer(tagContent)
            } else {
              this.$message.error(res.message)
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    getTagTreeMenu() {
      this.spinning = true;
      let body = {};
      tagManagementService
        .getFitlerMyTagTree(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.labelFilterOption = res.data;
              // 一级二级标签禁用
              this.labelFilterOption.forEach(item => {
                item.disabled = true
                item.children.forEach(childItem => {
                  childItem.disabled = true
                })
              })
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
      setTimeout(() => {
        this.spinning = false;
      }, 700);
    },
    showMyTagTime(value) {
      if (typeof value == "undefined" || value == null || value == '-') {
        return "-";
      }
      return utils.formatDate(new Date(value), "yyyy-MM-dd hh:mm:ss");
    },
    sortOptions(options) {
      var newOptions = options;
      for (var i = 0; i < options.length; i++) {
        var level_1 = options[i].children;
        var newChildren = [];
        for (var inx = 0; inx < 4; inx++) {
          newChildren.push(null);
        }
        for (var j = 0; j < level_1.length; j++) {
          if (level_1[j].tag_level_2 == 'Online User') {
            newChildren[0] = level_1[j];
          } else if (level_1[j].tag_level_2 == 'Digital Engagement') {
            newChildren[1] = level_1[j];
          } else if (level_1[j].tag_level_2 == 'Online Purchase') {
            newChildren[2] = level_1[j];
          }
          // else if(level_1[j].tag_level_2 == 'CRM Membership') {
          //   newChildren[3] = level_1[j];
          // }
        }
        // 将占空位的数据删除
        for (var m = 0; m < newChildren.length;) {
          if (typeof newChildren[m] == "undefined" || newChildren[m] == null) {
            newChildren.splice(m, 1);
          } else {
            m++;
          }
        }
        newOptions[i].children = newChildren;
      }
      return newOptions;
    }
  }
}
</script>
<style scoped>
.button-div {
  margin-top: 30px;
  float: right;
}

.button-div button,
.inner-add-filter button {
  margin-left: 20px;
}

.check-box-div {
  line-height: 32px;
  margin-top: 30px;
  float: left;
}

.filter-card {
  margin-top: 30px;
}

.inner-add-filter {
  float: right;
}

.close-total-filter {
  float: right;
  margin: -20px -15px;
}

.filter-card-different {
  margin-top: 30px;
  background: #f5f5f5;
}

.different-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 30px;
}

.my-tag.ant-tag {
  margin-bottom: 20px;
  background-color: rgba(239, 226, 81, 0.4);
  border-color: orange;
  /*color: orange;*/
  color: black;
  cursor: pointer;
}

.tab-no-border {
  margin-bottom: -33px;
}

/*标签预览背景色*/
.btn .ant-btn {
  background-image: linear-gradient(to right, #FFBC0D, #FBBE00, #FBBE00, #FBBE00, #FBBE00, #FFBC0D);
}

.unionFormCard {
  border: 1px solid rgba(11, 28, 57, 0.05);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 4px rgba(11, 28, 57, 0.05);
}



.collapse-panel-mytitle::before {
  content: "";
  width: 5px;
  height: 26px;
  position: absolute;
  top: 10px;
  left: 6px;
  background: #efe251;
}

.yellow {
  color: #FFBC0D;

}

.tab-and-or ::v-deep .ant-tabs-card-bar .ant-tabs-tab {
  background: #ffffff !important;
  font-weight: 400;
  color: #D8D8D8;
  font-size: 14px !important;
  border-radius: 4px !important;
  border: 1px solid #D8D8D8;
}

.tab-and-or ::v-deep .ant-tabs-card-bar .ant-tabs-tab-active.ant-tabs-tab {
  background: #000000 !important;
  border-radius: 4px !important;
  font-weight: 400 !important;
  color: var(--main-color) !important;
  font-size: 14px !important;
  background-image: none !important;
  box-shadow: none;
}

.tab-and-or ::v-deep .ant-tabs-tab:nth-child(2) {
  margin-left: 20px;
}

.header-title ::v-deep .ant-card-head-title {
  font-weight: 600 !important;
}

.header-title ::v-deep .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),
.header-title ::v-deep .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover,
.header-title ::v-deep .ant-select-dropdown-menu-item-selected,
.header-title ::v-deep .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--main-color) !important;
}
</style>